import React from "react";

const G = window.glob;

const CustomerIcon = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.uid = G.generateUid('AppInfoIcon');
		if ( props.icon ) {
			this.state.icon = props.icon;
		} else if ( props.info ) {
			if ( props.info?.icon ) this.state.icon = props.info.icon;
		} else {
			const info = G.getStatus('AppInfo');
			if ( info?.icon ) this.state.icon = info.icon;
		}
	}
	render() {
		if ( this.state.icon ) return <img key="icon" src={this.state.icon} className={"CustomerIcon"} alt={""} />;
		return '';
	}
}
export default CustomerIcon;
